import { render, staticRenderFns } from "./DeliveryConfigList.vue?vue&type=template&id=5d6163fe&"
import script from "./DeliveryConfigList.vue?vue&type=script&lang=ts&"
export * from "./DeliveryConfigList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports